var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('beast-header'),_c('div',{staticClass:"container"},[_c('beast-search-box',{attrs:{"query":_vm.searchQuery},on:{"searchEnded":_vm.updateSearch}}),_c('beast-packages-list',{attrs:{"toSearchQuery":_vm.searchQuery,"page":_vm.page,"size":_vm.size},on:{"keywordSearch":_vm.updateSearch,"updateUrl":_vm.updateURL}})],1),_c('beast-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }